/* @ngInject */
function BackofficeGeneralSettingsController ($scope, $translate, $timeout, $rootScope, ToastService, CustomerConfigurationsService, GeneralSettingsService, AdminService) {
  $scope.today = moment()
  $scope.companyStatusOptions = [
    {
      label: $translate.instant('activeTrial'),
      value: 'TRIAL_ACTIVE'
    },
    {
      label: $translate.instant('expiredTrial'),
      value: 'TRIAL_EXPIRED'
    },
    {
      label: $translate.instant('activeCustomerCompany'),
      value: 'CUSTOMER_ACTIVE'
    },
    {
      label: $translate.instant('churnedCustomerCompany'),
      value: 'CUSTOMER_CHURNED'
    },
    {
      label: $translate.instant('betaActiveCompany'),
      value: 'BETA_ACTIVE'
    },
    {
      label: $translate.instant('betaCanceledCompany'),
      value: 'BETA_CANCELED'
    }
  ]
  $scope.form = {
    companyStatus: null,
    companyName: null,
    companyUsersQuota: null,
    companyDomain: null,
    trialExpirationDate: null,
    inactivateUsers: false,
    companyStorage: null
  }
  $scope.savingGeneralSettings = false

  const lockedFields = {
    companyName: true,
    companyUsersQuota: true,
    companyDomain: true,
    companyStorage: true
  }
  const api = {
    _setInitialData,
    _isValidFormBeforeSave,
    _getUserCompanyWithoutCache
  }

  activate()
  async function activate () {
    const userCompany = await api._getUserCompanyWithoutCache()
    api._setInitialData(userCompany)
  }

  function _setInitialData (userCompany) {
    if (!userCompany) return

    $scope.form.companyStatus = $scope.companyStatusOptions.find(statusOpt => statusOpt.value === userCompany.status)
    $scope.form.companyName = userCompany.formattedName
    $scope.form.companyUsersQuota = userCompany.maxLicenses
    $scope.form.companyDomain = userCompany.subdomain
    $scope.form.trialExpirationDate = userCompany.trialExpirationDate
    $scope.form.companyStorage = userCompany.maxStorageGb
  }

  function _getUserCompanyWithoutCache () {
    const forceReloadUserCompany = true
    return $rootScope.getUserCompany(forceReloadUserCompany)
  }

  function _isValidFormBeforeSave () {
    if (!$scope.form.companyStatus?.value) {
      ToastService.showErrorToast($translate.instant('generalBackoffice.companySettings.errors.mustHaveStatus'))
      return false
    }
    if (['TRIAL_ACTIVE'].includes($scope.form.companyStatus?.value) && !$scope.form.trialExpirationDate) {
      ToastService.showErrorToast($translate.instant('generalBackoffice.companySettings.errors.mustHaveTrialExpirationDate'))
      return false
    }
    if (!$scope.form.companyName) {
      ToastService.showErrorToast($translate.instant('generalBackoffice.companySettings.errors.mustHaveName'))
      return false
    }
    if (!$scope.form.companyUsersQuota || $scope.form.companyUsersQuota < 1) {
      ToastService.showErrorToast($translate.instant('generalBackoffice.companySettings.errors.invalidUsersQuota'))
      return false
    }
    if (!$scope.form.companyStorage || $scope.form.companyStorage < 1) {
      ToastService.showErrorToast($translate.instant('generalBackoffice.companySettings.errors.invalidStorage'))
      return false
    }
    if ($scope.form.companyDomain && !$scope.form.companyDomain.match(/^[a-z0-9]*$/)) {
      ToastService.showErrorToast($translate.instant('generalBackoffice.companySettings.errors.invalidDomain'))
      return false
    }
    return true
  }

  $scope.resetFields = () => {
    api._getUserCompanyWithoutCache().then(userCompany => {
      api._setInitialData(userCompany)
    })
  }

  $scope.shouldShowInactivateUsers = () => {
    const isCompanyActive = ['CUSTOMER_ACTIVE', 'TRIAL_ACTIVE'].includes($rootScope.oUserCompany.status)
    const willCompanyBeInactive = ['CUSTOMER_CHURNED', 'TRIAL_EXPIRED'].includes($scope.form.companyStatus?.value)
    return isCompanyActive && willCompanyBeInactive
  }

  $scope.toggleEditableField = (field) => {
    lockedFields[field] = !lockedFields[field]
  }

  $scope.shouldDisableField = (field) => {
    return lockedFields[field]
  }

  $scope.saveSettings = async () => {
    if (!api._isValidFormBeforeSave()) return
    $timeout(() => {
      $scope.savingGeneralSettings = true
    })

    try {
      const companyWithBillingPackage = await $rootScope.getCompanyWithBillingPackage()
      // Realizamos 1 update de cada vez pra evitar erros de concorrência no banco de dados
      await GeneralSettingsService.updateCompany({
        company: {
          formattedName: $scope.form.companyName,
          subdomain: $scope.form.companyDomain
        }
      })
      await AdminService.updateCompanyBillingPackage(
        $rootScope.oUserCompany.id,
        companyWithBillingPackage.billingPackage.planId,
        { maxLicenses: $scope.form.companyUsersQuota, maxStorageGb: $scope.form.companyStorage }
      )
      await CustomerConfigurationsService.updateCompanyStatusAndTrial({
        status: $scope.form.companyStatus?.value,
        trialExpirationDate: $scope.form.trialExpirationDate,
        inactivateUsers: $scope.form.inactivateUsers
      })
      ToastService.defaultSuccessToast()
    } catch (error) {
      console.error(error)
      ToastService.defaultErrorToast()
    } finally {
      await api._getUserCompanyWithoutCache()
      $timeout(() => {
        $scope.savingGeneralSettings = false
      })
    }
  }

  /*
    Inicio: UDS Event Listeners
  */
  $scope.onChangeCompanyStatus = (event) => {
    const newValue = event?.detail?.value
    if (newValue !== 'TRIAL_ACTIVE') {
      $scope.form.trialExpirationDate = null
    }
    $scope.form.companyStatus = $scope.companyStatusOptions.find(statusOpt => statusOpt.value === newValue)
    $scope.form.inactivateUsers = false
  }

  $scope.onChangeInactivateUsers = (event) => {
    const newValue = event?.detail?.checked
    $scope.form.inactivateUsers = !!newValue
  }

  $scope.onChangeTrialExpirationDate = (event) => {
    const newValue = event?.detail?.date
    $scope.form.trialExpirationDate = newValue
  }

  $scope.onChangeCompanyName = (event) => {
    const newValue = event?.detail?.value
    $scope.form.companyName = newValue
  }

  $scope.onChangeCompanyUsersQuota = (event) => {
    const newValue = Number(event?.detail?.value)
    $scope.form.companyUsersQuota = newValue
  }

  $scope.onChangeCompanyCustomDomain = (event) => {
    const newValue = event?.detail?.value
    $scope.form.companyDomain = newValue
  }

  $scope.onChangeCompanyStorage = (event) => {
    const newValue = Number(event?.detail?.value)
    $scope.form.companyStorage = newValue
  }
  /*
    Fim: UDS Event Listeners
  */
}

export { BackofficeGeneralSettingsController }
